export default {"src":"/_next/static/media/applicant-age.6ac09e84.svg","height":23,"width":25};